import React from 'react';
import intl from 'react-intl-universal';
import Popup from 'react-popup';

class ParcelTable extends React.Component {
	constructor(props) {
		super(props);
		const initialCarrierId = props.order.carrier_id || '';
		this.state = {
			rows: [],
			selectedRowIndex: 0,
			isSelectDisabled: false,
			parcelSizes: props.order.parcel_sizes || [],
			defaultCarrierId: initialCarrierId,
			selectedCarrierId: initialCarrierId,
			showNonStandardCheckbox: false, //if isNonStandardInvisible is false, show checkbox
			isNonStandardInputChecked: false,
		};
	}

	componentDidMount() {
		this.defaultParcelSizes();
		this.setShowNonStandardCheckbox();
		this.setInitialSelectDisabled();
	}

	setShowNonStandardCheckbox = () => {
		const { available_carriers } = this.props;
		const { defaultCarrierId } = this.state;
		const selectedCarrier = available_carriers.find(c => c.id === defaultCarrierId);
		const isNonStandardInvisible = selectedCarrier ? selectedCarrier.non_standard_invisible : false;
		this.setState({ showNonStandardCheckbox: !isNonStandardInvisible });
	};

	defaultParcelSizes = () => {
		const { order } = this.props;

		if (!order || !Array.isArray(order.shipping_order_ids) || order.shipping_order_ids.length === 0) {
			this.setState({ rows: [] });
			return;
		}

		const parcels =
			order.shipping_order_ids && order.shipping_order_ids[0] && order.shipping_order_ids[0].shipping_parcels_ids;

		if (!Array.isArray(parcels)) {
			this.setState({ rows: [] });
			return;
		}

		const parcelData = parcels.map((parcel, index) => ({
			id: index + 1,
			weight: parcel.weight || 0,
			height: parcel.height || 0,
			length: parcel.length || 0,
			width: parcel.width || 0,
			size_id: parcel.size_id || null,
			size: parcel.size || null,
			size_label: '',
			waybill: !!parcel.waybill,
			type_id: parcel.type_id || '',
			shipping_id: parcel.shipping_id || 0,
		}));
		this.setState({ rows: parcelData }, () => {
			if (this.props.onParcelsChange) {
				this.props.onParcelsChange(this.state.rows);
			}
		});
	};

	handleInputChange = (e, index) => {
		const { name, value } = e.target;
		const field = name.split('_')[0];

		this.setState(
			prevState => {
				const updatedRows = [...prevState.rows];

				if (field === 'size') {
					const selected = (this.state.parcelSizes || []).find(s => String(s[0]) === String(value));
					updatedRows[index].size_id = selected ? selected[0] : '';
					updatedRows[index].size = selected ? selected[1] : '';
				} else {
					updatedRows[index][field] = value;
				}

				return { rows: updatedRows };
			},
			() => {
				if (this.props.onParcelsChange) {
					this.props.onParcelsChange(this.state.rows);
				}
				if (field === 'size' && this.props.clearErrorRow) {
					this.props.clearErrorRow(index);
				}
			}
		);
	};

	addRow = () => {
		const { rows } = this.state;
		const newRow = {
			id: rows.length + 1,
			weight: '',
			height: '',
			length: '',
			width: '',
			size: null,
			size_label: '',
			waybill: false,
			type_id: '',
			shipping_id: 0,
		};
		this.setState({ rows: [...rows, newRow] }, () => {
			if (this.props.onParcelsChange) {
				this.props.onParcelsChange(this.state.rows);
			}
		});
	};

	deleteRow = index => {
		const { rows, selectedRowIndex } = this.state;
		const isDeletingSelectedRow = selectedRowIndex === index;

		rows.splice(index, 1);
		rows.forEach((row, idx) => {
			row.id = idx + 1;
		});

		const newSelectedIndex = isDeletingSelectedRow
			? null
			: selectedRowIndex > index
			? selectedRowIndex - 1
			: selectedRowIndex;

		this.setState({ rows, selectedRowIndex: newSelectedIndex }, () => {
			if (this.props.onParcelsChange) {
				this.props.onParcelsChange(this.state.rows);
			}
		});
	};

	returnWaybill = id => {
		const { generateReturnWaybill } = this.props;
		generateReturnWaybill(id);
	};

	selectRow = index => {
		this.setState(prevState => ({
			selectedRowIndex: prevState.selectedRowIndex === index ? null : index,
		}));
	};

	stopPropagation = e => {
		e.stopPropagation();
	};

	/**
	 * Renders the available carriers dropdown.
	 * @returns {JSX.Element}
	 */
	availableCarriers = () => {
		const { available_carriers } = this.props;
		const { showNonStandardCheckbox, selectedCarrierId } = this.state;

		return (
			<div>
				<select name='carrier_id' onChange={this.carrierChange} value={selectedCarrierId}>
					{available_carriers.map(carrier => (
						<option key={carrier.id} value={carrier.id}>
							{carrier.name}
						</option>
					))}
				</select>

				{showNonStandardCheckbox && (
					<div className='non-standard-checkbox'>
						<label>
							<input type='checkbox' name='non_standard_package' onChange={this.handleNonStandardChange} />
							{intl.get('Niestandardowa przesyłka')}
						</label>
					</div>
				)}
			</div>
		);
	};

	/**
	 * Handles changes to the carrier select element.
	 * @param {*} event - The event object.
	 */
	carrierChange = event => {
		const { available_carriers, onCarrierChange } = this.props;
		const selectedCarrierId = Number(event.target.value);

		const carrier = available_carriers.find(c => c.id === selectedCarrierId);

		if (carrier) {
			const parcelSizes = carrier.sizes;
			const isNonStandardInvisible = carrier.non_standard_invisible;

			const updatedRows = this.state.rows.map(row => ({
				...row,
				size: null,
				size_label: '',
			}));

			this.setState(
				{
					parcelSizes: parcelSizes,
					isSelectDisabled: parcelSizes.length === 0,
					showNonStandardCheckbox: isNonStandardInvisible === false,
					selectedCarrierId: selectedCarrierId,
					rows: updatedRows,
				},
				() => {
					if (onCarrierChange) {
						onCarrierChange(selectedCarrierId);
					}

					if (this.props.onSelectDisabledChange) {
						this.props.onSelectDisabledChange(this.state.isSelectDisabled);
					}

					if (this.props.onParcelsChange) {
						this.props.onParcelsChange(this.state.rows);
					}
				}
			);
		}
	};

	/**
	 * Sets the initial state for the select element's disabled status.
	 */
	setInitialSelectDisabled = () => {
		const { available_carriers, onSelectDisabledChange } = this.props;
		const { defaultCarrierId } = this.state;

		const selectedCarrier = available_carriers.find(c => c.id === defaultCarrierId);

		if (selectedCarrier) {
			const parcelSizes = selectedCarrier.sizes;
			const isSelectDisabled = parcelSizes.length === 0;

			this.setState({ isSelectDisabled });

			if (onSelectDisabledChange) {
				onSelectDisabledChange(isSelectDisabled);
			}
		}
	};

	/**
	 * Handles changes to the non-standard package checkbox.
	 * @param {*} e - The event object.
	 */
	handleNonStandardChange = e => {
		const { checked } = e.target;
		this.setState({ isNonStandardInputChecked: checked });

		if (this.props.onNonStandardCheckedChange) {
			this.props.onNonStandardCheckedChange(checked);
		}
	};

	/**
	 * Applies a material product to the specified row if a matching EAN is found.
	 * @param {*} ean - The EAN code to match.
	 * @param {*} materialProducts - The list of material products to search.
 	 * @param {Array} [materialSizeIds] - IDs of the material product sizes (generated internally from match.sizes).
     * Used to check compatibility with the selected carrier's parcel sizes.
	 * @returns {boolean} - True if a matching product was found, false otherwise.
	 */
	applyMaterialProductToRow = (ean, materialProducts) => {
		const match = materialProducts.find(p => p.barcode.toString() === ean.toString());
		
		if (!match) return false;

		const { parcelSizes } = this.state;

		const materialSizeIds = Array.isArray(match.sizes)
			? match.sizes.map(s => (typeof s === 'object' && s.id ? parseInt(s.id, 10) : parseInt(s, 10)))
			: [];

		const allowedSizes = parcelSizes.map(s => (Array.isArray(s) ? parseInt(s[0], 10) : parseInt(s, 10)));
		const isCompatible = allowedSizes.length === 0 || materialSizeIds.some(id => allowedSizes.includes(id));

		if (!isCompatible) {
			this.notCompatiblePopup(match.name);
			return true;
		}

		// Prefer the first carrier size that matches the material sizes to avoid fallback options.
		const selectedSize =
			parcelSizes.length > 0 && materialSizeIds.length > 0
				? parcelSizes.find(s => materialSizeIds.includes(parseInt(s[0], 10)))
				: null;

		this.setState(
			prevState => {
				let rows = Array.isArray(prevState.rows) ? [...prevState.rows] : [];
				let selectedIndex = prevState.selectedRowIndex;

				const materialSizeId = materialSizeIds.length > 0 ? materialSizeIds[0] : null;


				if (selectedIndex === null || !rows[selectedIndex]) {
					const newRow = {
						id: rows.length + 1,
						weight: match.weight,
						height: match.height,
						length: match.length,
						width: match.width,
						size_id: selectedSize ? selectedSize[0] : materialSizeId,
						size: selectedSize ? selectedSize[1] : match.name,
						size_label: match.name,
						waybill: false,
						type_id: '',
						shipping_id: 0,
						material_id: match.id,
						material_name: match.name,
						barcode: match.barcode,
					};
					rows.push(newRow);
					selectedIndex = null;
				} else {
					rows[selectedIndex] = {
						...rows[selectedIndex],
						weight: match.weight === 0 && rows[selectedIndex].weight !== '' ? rows[selectedIndex].weight : match.weight,
						height: match.height,
						length: match.length,
						width: match.width,
						material_id: match.id,
						material_name: match.name,
						barcode: match.barcode,
						size_id: selectedSize ? selectedSize[0] : materialSizeId,
						size: selectedSize ? selectedSize[1] : match.name,
						size_label: match.name,
					};
					selectedIndex = null;
				}

				return { rows, selectedRowIndex: selectedIndex };
			},
			() => {
				if (this.props.onParcelsChange) this.props.onParcelsChange(this.state.rows);
			}
		);

		return true;
	};

	notCompatiblePopup = matchName => {
		Popup.create({
			content: intl.get('parcel_not_compatible', { name: matchName }),
			buttons: {
				right: [
					{
						text: 'OK',
						className: 'ok',
						key: 'enter',
						action: function () {
							Popup.close();
						},
					},
				],
			},
		});
	};

	render() {
		const { rows, selectedRowIndex, parcelSizes, isSelectDisabled } = this.state;
		const { rowsWithErrors = [] } = this.props;
		return (
			<div className='carrier f_group inventory_materials_shipment ignore-scanner-focus'>
				<div className='carriers-container'>{this.availableCarriers()}</div>
				<table className='parcels table'>
					<thead>
						<tr>
							<th>#</th>
							<th className='right'>{intl.get('Waga')}</th>
							<th className='right'>{intl.get('Wysokość')}</th>
							<th className='right'>{intl.get('Długość')}</th>
							<th className='right'>{intl.get('Szerokość')}</th>
							<th className='right'>{intl.get('Rozmiar')}</th>
							<th></th>
							{this.props.showGenerateReturnWaybill && <th></th>}
						</tr>
					</thead>
					<tbody>
						{rows.map((row, index) => (
							<tr
								key={row.id}
								className={index === selectedRowIndex ? 'selected' : ''}
								onClick={() => this.selectRow(index)}>
								<td title={intl.get('Zaznacz wiersz')} className='id cursor-pointer'>
									{row.id}
								</td>
								<td>
									<input
										type='number'
										step='1'
										name={`weight_${row.id}`}
										value={row.weight}
										onChange={e => this.handleInputChange(e, index)}
										onClick={this.stopPropagation}
										disabled={row.waybill}
									/>
								</td>
								<td>
									<input
										type='number'
										step='1'
										name={`height_${row.id}`}
										value={row.height}
										onChange={e => this.handleInputChange(e, index)}
										onClick={this.stopPropagation}
										disabled={row.waybill}
									/>
								</td>
								<td>
									<input
										type='number'
										step='1'
										name={`length_${row.id}`}
										value={row.length}
										onChange={e => this.handleInputChange(e, index)}
										onClick={this.stopPropagation}
										disabled={row.waybill}
									/>
								</td>
								<td>
									<input
										type='number'
										step='1'
										name={`width_${row.id}`}
										value={row.width}
										onChange={e => this.handleInputChange(e, index)}
										onClick={this.stopPropagation}
										disabled={row.waybill}
									/>
								</td>
								<td>
									<select
										name={`size_${row.id}`}
										value={parcelSizes.length > 0 ? (row.size_id || '') : ''}
										onClick={this.stopPropagation}
										onChange={e => this.handleInputChange(e, index)}
										disabled={row.waybill || isSelectDisabled}
										className={rowsWithErrors.includes(index) ? 'error' : ''}>
										<option value=''></option>
										{parcelSizes.map((size, sizeIndex) => (
											<option key={sizeIndex} value={size[0]}>
												{size[1]}
											</option>
										))}
										{row.size_id && parcelSizes.length > 0 && !parcelSizes.some(s => s[0] == row.size_id) && (
											<option value={row.size_id}>
												{row.size_label || row.size}
											</option>
										)}
									</select>
								</td>
								<td>
									<button title={intl.get('Usuń')} onClick={() => this.deleteRow(index)}>
										{intl.get('Usuń')}
									</button>
								</td>
								{this.props.showGenerateReturnWaybill && (
									<td>
										<button title={intl.get('Zwróć')} onClick={() => this.returnWaybill(row.shipping_id)}>
											{intl.get('Zwróć')}
										</button>
									</td>
								)}
							</tr>
						))}
					</tbody>
				</table>
				<button title={intl.get('Dodaj pozycję')} className='addRow' id='addRowButton' onClick={this.addRow}>
					{intl.get('Dodaj pozycję')}
				</button>
			</div>
		);
	}
}

export default ParcelTable;
